import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import type { VisitorConsentDocument } from "./visitor-consent-documents.context";

type P = {
  document: VisitorConsentDocument;
  canDelete: boolean;
  onEdit: (doc: VisitorConsentDocument) => void;
  onRequestDelete: (doc: VisitorConsentDocument) => void;
};

export function VisitorConsentDocumentsTableActionsCell({
  document,
  canDelete,
  onEdit,
  onRequestDelete
}: P) {
  const { t } = useTranslation();
  const deleteTooltipTitle = canDelete
    ? t("_visitorConsentDocuments_delete")
    : t("_visitorConsentDocuments_deleteBlocked");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 0.5,
        flexWrap: "nowrap"
      }}
      data-testid={`visitor-consent-doc-actions-${document.id}`}
    >
      <Tooltip title={<Typography>{t("_visitorConsentDocuments_edit")}</Typography>}>
        <IconButton
          aria-label={t("_visitorConsentDocuments_edit")}
          onClick={() => onEdit(document)}
          data-testid={`visitor-consent-doc-edit-${document.id}`}
          size="large"
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={<Typography>{deleteTooltipTitle}</Typography>}>
        <IconButton
          aria-label={t("_visitorConsentDocuments_delete")}
          disabled={!canDelete}
          onClick={() => onRequestDelete(document)}
          data-testid={`visitor-consent-doc-delete-${document.id}`}
          size="large"
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
